import { useEffect, useRef } from 'react';
import { useI18n } from '../i18n/i18n';

import './RSVP.scss';

import plusOne from '../img/svg/person-badge-plus-svgrepo-com.svg';
import car from '../img/svg/car-salesman-service-svgrepo-com.svg';
import mappp from '../img/svg/map-svgrepo-com.svg';
import taxi from '../img/svg/taxi-taxi-stop-svgrepo-com.svg';
import bbq from '../img/svg/bbq-svgrepo-com.svg';
import party from '../img/svg/party-horn-svgrepo-com.svg';
import day from '../img/svg/day-cloud-svgrepo-com.svg';
import m from '../img/svg/bouquet-svgrepo-com.svg';
import v from '../img/svg/bowtie-svgrepo-com.svg';
import vacsi from '../img/svg/plate-and-utensils-top-view-svgrepo-com.svg';
import formm from '../img/svg/form-svgrepo-com.svg';
import ext from '../img/svg/external-link-svgrepo-com.svg';
import { Food } from './Food';
import { isToday } from '../after';

export function RSVP() {
    const t = useI18n();
    const boxRef = useRef(null);

    useEffect(() => {
        document.body.classList.add('rsvp-page');
        // window.scrollTo(0, 0);
        return () => {
            document.body.classList.remove('rsvp-page');
        }
    }, []);

    const renderCTA = () => {
        return <div className="form-link-container">
            <a className="google-form-link" href={t.rsvpPage.forms.inv} rel="noopener noreferrer" target="_blank">
                <Icon src={formm} alt="Google Forms" classNames={['small']}/>
                <span>{t.rsvpPage.invitation}</span>
                <Icon src={ext} alt="Open" classNames={['tiny']}/>
            </a>
            <div className="dot-dot-dot"/>
            <a className="google-form-link" href={t.rsvpPage.forms.menu} rel="noopener noreferrer" target="_blank">
                <Icon src={formm} alt="Google Forms" classNames={['small']}/>
                <span>{t.rsvpPage.dinnerTitle}</span>
                <Icon src={ext} alt="Open" classNames={['tiny']}/>
            </a>
        </div>;
    }

    if (isToday()) {
        return <div id="rsvp">
            <section className="qqq">
                <div className="list-of-q">
                    <div className="q two"/>
                    <h3>{t.rsvpPage.dinner.title}</h3>
                    <div className="q2">
                        <div className="q">
                            <div>
                                <Icon src={m} alt="Menyasszony" classNames={['gold6']}/>
                                <Icon src={vacsi} alt="Kedvence" classNames={['gold6']}/>
                            </div>
                            <div>{t.rsvpPage.dinner.bride}</div>
                        </div>
                        <div className="q">
                            <div>
                                <div>
                                    <Icon src={v} alt="Vőlegény" classNames={['gold6']}/>
                                    <Icon src={vacsi} alt="Kedvence" classNames={['gold6']}/>
                                </div>
                                <div>{t.rsvpPage.dinner.groom}</div>
                            </div>
                            <div></div>
                        </div>
                    </div>
                    <Food/>
                </div>
            </section>
            <div className="dev">
                <span style={{ padding: '8px', opacity: 0.5 }}>{t.rsvpPage.by}</span>
            </div>
        </div>
    }

    return <div id="rsvp">
        <section className="rsvp-page dark">
            <div className="art">
                <h1>RSVP</h1>
                <p>{t.rsvpPage.subtitle}</p>
                <div className="line"/>
                <span className="rsvp-small">RSVP</span>
                {/* https://codepen.io/Coding-Star/pen/WNpbvwB */}
                <div className="envlope-box" ref={boxRef}>
                    <div className="wrapper">
                        <div className="lid one"></div>
                        <div className="lid two"></div>
                        <div className="envelope"></div>
                        <div className="letter">
                            <p style={{ marginTop: '4px', marginBottom: 0 }}>
                                <small>{t.rsvpPage.letter.greeting}</small>
                                <div>
                                    <small>{t.rsvpPage.letter.message}</small>
                                </div>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section className="qqq">
            <h2>{t.rsvpPage.greeting}</h2>
            <p>{t.rsvpPage.instruction}</p>
            <div className="list-of-q">
                <h3>{t.rsvpPage.arrival.title}</h3>
                <div className="q one">
                    <div>
                        <Icon src={plusOne} alt="Plusz egy fő" classNames={['gold6']}/>
                    </div>
                    <div>{t.rsvpPage.arrival.question}</div>
                </div>
                <div className="q two">
                    <div>
                        <Icon src={car} alt="Autóval?" classNames={['gold6']}/>
                        <Icon src={taxi} alt="Taxival?"/>
                        <Icon src={mappp} alt="Helyszín" classNames={['gold6']}/>
                    </div>
                    <div>{t.rsvpPage.arrival.how}</div>
                </div>
                <h3>{t.rsvpPage.dinner.title}</h3>
                <div className="q2">
                    <div className="q">
                        <div>
                            <Icon src={m} alt="Menyasszony" classNames={['gold6']}/>
                            <Icon src={vacsi} alt="Kedvence" classNames={['gold6']}/>
                        </div>
                        <div>{t.rsvpPage.dinner.bride}</div>
                    </div>
                    <div className="q">
                        <div>
                            <div>
                                <Icon src={v} alt="Vőlegény" classNames={['gold6']}/>
                                <Icon src={vacsi} alt="Kedvence" classNames={['gold6']}/>
                            </div>
                            <div>{t.rsvpPage.dinner.groom}</div>
                        </div>
                        <div></div>
                    </div>
                </div>
                <Food/>
                <h3>{t.rsvpPage.nextDay.title}</h3>
                <div className="q bbq">
                    <div>
                        <Icon src={day} alt="Másnap" classNames={['gold6']}/>
                        <Icon src={bbq} alt="Barbeque" classNames={['gold6']}/>
                        <Icon src={party} alt="party" classNames={['gold6']}/>
                    </div>
                    <div>{t.rsvpPage.nextDay.question}</div>
                </div>
            </div>
        </section>
        <section className="cta-section half dark">
            <h2>{t.rsvpPage.cta.title}</h2>
            <div className="cta-big">
                <p>{t.rsvpPage.cta.message}</p>
                {renderCTA()}
            </div>
        </section>
        <div className="dev">
            <span style={{ padding: '8px', opacity: 0.5 }}>{t.rsvpPage.by}</span>
        </div>
    </div>
}

export function Icon({ src, alt, classNames = [] }) {
    return <img className={['img-svg-icon', ...classNames].filter(Boolean).join(' ')} alt={alt} src={src}/>
}
